export default __webpack_public_path__ + "static/media/schoolLogo.7b0e50ca.png";